import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { allProductsAction } from "../../redux/actions/productActions";
import LoaderBlock from "../loader/LoaderBlock";
import SingleProduct from "./SingleProduct";
import { toast } from "react-toastify";


const ProductCatalog = () => {


    const dispatch = useDispatch()

    const { loading, products, totalPages, totalProducts } = useSelector(state => state.products)
    const { error, message } = useSelector(state => state.productMessage)


    const [page, setPage] = useState(1)


    const [scan_code, setScan_code] = useState('');
    const [description, setDescription] = useState('');
    const [department, setDepartment] = useState('');



    useEffect(() => {
        const Headerlinkks = document.querySelectorAll(".headerLinks");
        const element = document.getElementById("productCatalog");

        Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
        element?.classList.add("activeHeaderLink");

        document.title = `Inventory - Admin Panel`;



    }, []);


    useEffect(() => {


        const query = {}

        let scan_codeQuery = scan_code;

        if (scan_code.length === 8) {
            if (!/^\d{8}$/.test(scan_code)) {
                toast.error("Invalid UPC-E format");
            }

            const S = scan_code[0];           // Number system
            const a = scan_code[1];
            const b = scan_code[2];
            const c = scan_code[3];
            const d = scan_code[4];
            const e = scan_code[5];
            const N = scan_code[6];           // Expansion digit
            // const X = upc[7];        // Old check digit (we will recalc)

            let expanded;

            if (["0", "1", "2"].includes(N)) {
                expanded = `${S}${a}${b}${N}0000${c}${d}${e}`;
            }
            else if (N === "3") {
                expanded = `${S}${a}${b}${c}00000${d}${e}`;
            }
            else if (N === "4") {
                expanded = `${S}${a}${b}${c}${d}00000${e}`;
            }
            else {
                expanded = `${S}${a}${b}${c}${d}${e}0000${N}`;
            }

            // Now calculate new UPC-A check digit (12th digit)
            let sum = 0;
            for (let i = 0; i < 11; i++) {
                const digit = parseInt(expanded[i]);
                sum += (i % 2 === 0) ? digit * 3 : digit;
            }

            const checkDigit = (10 - (sum % 10)) % 10;

            scan_codeQuery = expanded + checkDigit;
        }

        if (scan_code) query.scan_code = scan_codeQuery;
        if (description) query.description = description;
        if (department) query.department = department;


        dispatch(allProductsAction(page, query));

    }, [page, scan_code, description, department, dispatch]);


    useEffect(() => {
        if (error) {
            toast.error(error)
        }
        if (message) {
            toast.success(message)
            const query = {}







            if (scan_code) query.scan_code = scan_code;
            if (description) query.description = description;
            if (department) query.department = department;
            dispatch(allProductsAction(page, query));

        }
    }, [message, error, dispatch, scan_code, description, department, page]);


    return (
        <Fragment>
            <section className="pl-[1.5vmax] pr-[2.5vmax]">
                <div className="flex justify-between items-center bg-white p-[1.2vmax] rounded-[1vmax] px-[2vmax]">
                    <h2 className="text-[1.3vmax] font-bold">Product Catalog</h2>

                    <div className="flex-center gap-[0.8vmax] text-[1vmax]">
                        <Link to={"/"}>Dashboard</Link>
                        <div className="w-[0.3vmax] h-[0.3vmax] rounded-[50%] bg-black"></div>
                        <span className="text-slate-400">Product Catalog</span>
                    </div>
                </div>
            </section>
            <section className="pl-[1.5vmax] pr-[2.5vmax] mt-[1vmax]">
                <div className="p-[2vmax] bg-white shadow-1 rounded-2xl pb-0">
                    <div className="flex gap-[1vmax]">
                        <div className="w-[18%] flex items-center border-[0.15vmax] border-gray-300 p-[0.5vmax_0.7vmax] rounded-lg h-fit">
                            <span className="text-[1vmax]  text-gray-300 inline-block w-[20%]" >
                                <i className="fa-solid fa-magnifying-glass"></i>
                            </span>
                            <input type="text" className="w-[80%] text-[1vmax] font-2 outline-none" placeholder="scan Code ..."
                                value={scan_code}
                                onChange={(e) => {
                                    setScan_code(e.target.value)
                                    setPage(1)
                                }}
                            />
                        </div>
                        <div className="w-[20%] flex items-center border-[0.15vmax] border-gray-300 p-[0.5vmax_0.7vmax] rounded-lg h-fit">
                            <span className="text-[1vmax]  text-gray-300 inline-block w-[20%]" >
                                <i className="fa-solid fa-magnifying-glass"></i>
                            </span>
                            <input type="text" className="w-[80%] text-[1vmax] font-2 outline-none" placeholder="Description ..."
                                value={description}
                                onChange={(e) => {
                                    setDescription(e.target.value)
                                    setPage(1)
                                }}
                            />
                        </div>
                        <div className="w-[20%] flex items-center border-[0.15vmax] border-gray-300 p-[0.5vmax_0.7vmax] rounded-lg h-fit">
                            <span className="text-[1vmax]  text-gray-300 inline-block w-[20%]" >
                                <i className="fa-solid fa-magnifying-glass"></i>
                            </span>
                            <input type="text" className="w-[80%] text-[1vmax] font-2 outline-none" placeholder="department ..."
                                value={department}
                                onChange={(e) => {
                                    setDepartment(e.target.value)
                                    setPage(1)
                                }}
                            />
                        </div>
                    </div>
                    <div className="mt-[2vmax] w-full overflow-x-auto my-scroll pb-[2vmax]">



                        {loading ? (
                            <LoaderBlock />
                        ) : (
                            <>

                                {products?.length === 0 ? (
                                    <div className="text-center text-[2vmax] py-[3vmax]">
                                        No Product Found
                                    </div>
                                ) : (
                                    <>
                                        <div className="flex  w-[120%] 2xl:w-full bg-slate-100">
                                            <div className="flex-[0.8] flex items-center justify-center p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[600] 2xl:text-[0.7vmax] text-slate-700">
                                                No.
                                            </div>
                                            <div className="flex-[1.6] flex items-center justify-start p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[600] 2xl:text-[0.7vmax] text-slate-700">
                                                Scan Code
                                            </div>
                                            <div className="flex-[2] flex items-center justify-center p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[600] 2xl:text-[0.7vmax] text-slate-700">
                                                Description
                                            </div>
                                            <div className="flex-[1] flex items-center justify-center p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[600] 2xl:text-[0.7vmax] text-slate-700">
                                                Unit/Case
                                            </div>
                                            <div className="flex-[2] flex items-center justify-center p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[600] 2xl:text-[0.7vmax] text-slate-700">
                                                Department
                                            </div>

                                            <div className="flex-[1] flex items-center justify-center p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[600] 2xl:text-[0.7vmax] text-slate-700 text-center">
                                                Purchase QTY
                                            </div>
                                            <div className="flex-[1] flex items-center justify-center p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[600] 2xl:text-[0.7vmax] text-slate-700">
                                                Sold  QTY
                                            </div>
                                            <div className="flex-[1] flex items-center justify-center p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[600] 2xl:text-[0.7vmax] text-slate-700">
                                                Adjust QTY
                                            </div>
                                            <div className="flex-[1] flex items-center justify-center p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[600] 2xl:text-[0.7vmax] text-slate-700 text-center">
                                                Current QTY
                                            </div>
                                            <div className="flex-[1] flex items-center justify-center p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[600] 2xl:text-[0.7vmax] text-slate-700">
                                                Each Cost
                                            </div>
                                            <div className="flex-[1] flex items-center justify-center p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[600] 2xl:text-[0.7vmax] text-slate-700">
                                                Each Retail
                                            </div>
                                            <div className="flex-[1.5] flex items-center justify-center p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[600] 2xl:text-[0.7vmax] text-slate-700">
                                                Total Cost
                                            </div>
                                            <div className="flex-[1.5] flex items-center justify-center p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[600] 2xl:text-[0.7vmax] text-slate-700 text-center">
                                                Total Retail
                                            </div>
                                            <div className="flex-[1.2] flex items-center justify-center p-[0.4vmax] border-[0.1vmax] border-gray-300 text-[1vmax] font-[600] 2xl:text-[0.7vmax] text-slate-700">
                                                Action
                                            </div>
                                        </div>
                                        {
                                            products?.map((product, index) => (
                                                <SingleProduct product={product} index={totalProducts - (index + 1 + ((page - 1) * 20))} />
                                            ))
                                        }
                                    </>
                                )
                                }
                            </>
                        )
                        }
                    </div>
                </div>
            </section>
            {totalPages > 1 && (
                <div className="flex gap-[1vmax] justify-center mt-[2vmax]">

                    {/* Prev button */}
                    <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    {/* --- SMART PAGINATION START --- */}
                    {(() => {
                        const pages = [];
                        const maxVisible = 3; // number of pages to show around current page

                        const addPage = (p) => {
                            pages.push(
                                <button
                                    key={p}
                                    className={`pagination-btn ${page === p ? "active" : ""}`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        };

                        // Always show First Page
                        addPage(1);

                        // Left dots
                        if (page > maxVisible + 2) {
                            pages.push(<span key="dots-left">...</span>);
                        }

                        // Middle pages (dynamic)
                        for (
                            let p = Math.max(2, page - maxVisible);
                            p <= Math.min(totalPages - 1, page + maxVisible);
                            p++
                        ) {
                            addPage(p);
                        }

                        // Right dots
                        if (page < totalPages - (maxVisible + 1)) {
                            pages.push(<span key="dots-right">...</span>);
                        }

                        // Always show Last Page
                        if (totalPages > 1) {
                            addPage(totalPages);
                        }

                        return pages;
                    })()}
                    {/* --- SMART PAGINATION END --- */}

                    {/* Next button */}
                    <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>

                </div>
            )}



            <br />
            <br />
            <br />
            <br />
            <br />
        </Fragment>
    );
};

export default ProductCatalog;
